export default __webpack_public_path__ + "static/media/clients.4549dc43.svg";